export default __webpack_public_path__ + "static/media/dropdown-disable.4dd4bae1.svg";